import dayjs from "dayjs";
import { useMemo } from "react";
import { StyledDatePicker, StyledRangePicker } from "./styles";
import { isNonEmptyVariable } from "@/util/common_function";

const CommonDatePicker = ({
  value,
  onChange,
  placeholder = "Select date",
  format = "MM/DD/YYYY HH:mm",
  disabled = false,
  allowClear = true,
  disableFutureDates = false,
  fromDateDisable = "",
  range = false,
  showTime = true,
  isDOB = false,
  disablePastDate = false,
  ...rest
}) => {
  const disabledDate = (current) => {
    if (isDOB) {
      const earliest = dayjs("1900-01-01");
      const latest = dayjs();
      return current && (current < earliest || current > latest.endOf("day"));
    }

    if (disablePastDate) {
      return current < dayjs().startOf("day");
    }

    if (isNonEmptyVariable(fromDateDisable)) {
      return current && current < dayjs(fromDateDisable).endOf("day");
    } else {
      if (!disableFutureDates) return false;
      return current && current > dayjs().endOf("day");
    }
  };

  const PickerComponent = useMemo(
    () => (range ? StyledRangePicker : StyledDatePicker),
    [range]
  );

  return (
    <PickerComponent
      width="100%"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      format={{
        format: format,
        type: "mask",
      }}
      disabled={disabled}
      allowClear={allowClear}
      disabledDate={disabledDate}
      showTime={showTime}
      {...rest}
    />
  );
};

export default CommonDatePicker;
